import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Calculator, Users, Eye, HeartHandshake, PiggyBank } from 'lucide-react';
export function Features() {
  const features = [{
    icon: <BookOpen className="w-8 h-8 text-burgundy-600" data-id="element-46" />,
    title: 'Recetas irresistibles',
    desc: 'Budines suaves, húmedos y deliciosos que hacen que las personas quieran repetir.'
  }, {
    icon: <Calculator className="w-8 h-8 text-burgundy-600" data-id="element-47" />,
    title: 'Cómo calcular precios correctamente',
    desc: 'Para dejar de regalar tu trabajo y empezar a ganar de verdad.'
  }, {
    icon: <Users className="w-8 h-8 text-burgundy-600" data-id="element-48" />,
    title: 'Estrategias simples para conseguir clientes',
    desc: 'Incluso si hoy nadie te conoce.'
  }, {
    icon: <Eye className="w-8 h-8 text-burgundy-600" data-id="element-49" />,
    title: 'Técnicas de presentación',
    desc: 'Porque las personas compran primero con los ojos.'
  }, {
    icon: <HeartHandshake className="w-8 h-8 text-burgundy-600" data-id="element-50" />,
    title: 'Cómo vender sin sentir vergüenza',
    desc: 'Usando recomendaciones, redes sociales y marketing emocional.'
  }, {
    icon: <PiggyBank className="w-8 h-8 text-burgundy-600" data-id="element-51" />,
    title: 'Cómo empezar con bajo presupuesto',
    desc: 'Sin maquinaria costosa ni inversiones enormes.'
  }];
  return <section className="py-20 bg-cream-100 bg-texture" data-id="element-52">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl" data-id="element-53">
        {/* ¿Por qué la mayoría fracasa? */}
        <div className="max-w-3xl mx-auto text-center mb-20" data-id="element-54">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl font-bold text-brown-900 mb-8" data-id="element-55">
            ¿Por qué la mayoría fracasa antes de empezar?
          </motion.h2>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="space-y-4 text-lg text-brown-800/80" data-id="element-56">
            <p data-id="element-57">Porque intentan hacerlo solos.</p>
            <p data-id="element-58">
              Ven videos desordenados. Prueban recetas aleatorias. Copian
              precios incorrectos.
            </p>
            <p data-id="element-59">Y terminan frustrados.</p>
            <p className="font-bold text-xl text-burgundy-600 mt-6" data-id="element-60">
              Pero el verdadero problema NO es cocinar.
            </p>
            <p className="font-medium text-brown-900" data-id="element-61">
              El verdadero problema es no saber cómo transformar un producto
              casero en algo que las personas DESEEN comprar.
            </p>
            <p data-id="element-62">Ahí está la diferencia.</p>
          </motion.div>
        </div>

        {/* El error que casi todos cometen */}
        <div className="max-w-3xl mx-auto bg-white rounded-3xl p-8 sm:p-12 shadow-soft mb-24 border border-cream-200" data-id="element-63">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl font-bold text-brown-900 text-center mb-8" data-id="element-64">
            El error que casi todos cometen
          </motion.h2>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="space-y-6 text-lg text-center text-brown-800/80" data-id="element-65">
            <p data-id="element-66">La mayoría intenta vender “comida”.</p>
            <p className="font-medium text-brown-900" data-id="element-67">
              Pero eso no es lo que compra la gente.
            </p>
            <p data-id="element-68">La gente compra:</p>

            <div className="flex flex-wrap justify-center gap-3 my-6" data-id="element-69">
              {['✨ emoción', '✨ experiencia', '✨ calidez', '✨ placer', '✨ recuerdos'].map((item, i) => <span key={i} className="bg-cream-50 text-burgundy-700 px-4 py-2 rounded-full font-medium border border-cream-200" data-id="element-70">
                  {item}
                </span>)}
            </div>

            <p data-id="element-71">Cuando alguien prueba un budín delicioso…</p>
            <p data-id="element-72">no solo come.</p>
            <p className="font-bold text-2xl text-burgundy-600 my-4" data-id="element-73">Siente.</p>
            <p className="font-medium" data-id="element-74">
              Y cuando logras provocar esa sensación…
              <br data-id="element-75" />
              los clientes vuelven.
            </p>
          </motion.div>
        </div>

        {/* Lo que descubrirás */}
        <div className="text-center mb-12" data-id="element-76">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl sm:text-4xl font-bold text-brown-900 mb-4" data-id="element-77">
            Lo que descubrirás dentro de
            <br data-id="element-78" />
            <span className="text-burgundy-600" data-id="element-79">
              “Del Horno a Tu Primer Ingreso”
            </span>
          </motion.h2>
        </div>

        <div className="grid sm:grid-cols-2 gap-6" data-id="element-80">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-6 rounded-2xl shadow-sm border border-cream-200 hover:shadow-md transition-shadow" data-id="element-81">
              <div className="bg-cream-100 w-14 h-14 rounded-xl flex items-center justify-center mb-4" data-id="element-82">
                {feature.icon}
              </div>
              <h3 className="text-xl font-bold text-brown-900 mb-2" data-id="element-83">
                {feature.title}
              </h3>
              <p className="text-brown-800/80" data-id="element-84">{feature.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-16 text-center max-w-2xl mx-auto" data-id="element-85">
          <h3 className="text-2xl font-bold text-brown-900 mb-6" data-id="element-86">
            Lo mejor de todo…
          </h3>
          <p className="text-lg text-brown-800/80 mb-4" data-id="element-87">
            Este sistema fue creado para personas comunes.
          </p>
          <p className="text-lg text-brown-800/80 mb-4" data-id="element-88">
            No para chefs profesionales.
            <br data-id="element-89" />
            No para expertos en negocios.
          </p>
          <p className="text-xl font-bold text-burgundy-600 mb-8" data-id="element-90">
            Sino para personas que quieren empezar algo REAL desde cero.
          </p>

          <p className="text-lg text-brown-800/80 mb-6" data-id="element-91">Aunque hoy sientas:</p>
          <div className="flex flex-wrap justify-center gap-2 mb-8" data-id="element-92">
            {['miedo', 'dudas', 'inseguridad', 'vergüenza de vender', 'falta de experiencia'].map((item, i) => <span key={i} className="bg-white text-brown-800 px-4 py-1.5 rounded-full text-sm font-medium border border-cream-200 shadow-sm" data-id="element-93">
                {item}
              </span>)}
          </div>

          <p className="text-2xl font-bold text-brown-900 mb-2" data-id="element-94">
            Puedes hacerlo.
          </p>
          <p className="text-lg text-brown-800/80" data-id="element-95">
            Porque el método está diseñado paso a paso.
          </p>
        </motion.div>
      </div>
    </section>;
}